import { SchemaRefModel } from './DomainServiceModel';
import { SchemaValueBindingModel, SchemaValueModel } from './SchemaValueModel';
import { ExpressionModel } from './ExpressionModel';

export type Point = { x: number; y: number };

export type FlowNodeModel = {
	Id: string;
	Metadata: Record<string, unknown> & Point;
	Type: string;
};

export type FlowEdgeModel = {
	Id: string;
	Type?: string;
	To?: string;
	Condition?: Record<string, unknown>;
	InputOverrides?: ActivityTransitionAgentToolInputOverride[];
};

export type ActivityTransitionAgentToolInputOverride = {
  ActivityId: string;
  PropertyName: string;
  Enabled?: boolean | null;
  Description?: string;
  Override?: ExpressionModel;
};

export type ActivityModel = FlowNodeModel & {
	Transitions?: TransitionModel[];
} & Record<string, unknown>;

export type TransitionEdgeModel = FlowEdgeModel & {
	Type?: string;
	To?: string;
	Condition: Record<string, unknown>;
	CaptureToolCallTraceMetadata?: boolean;
	CaptureToolResponseTraceMetadata?: boolean;
};

export type FlowDefinitionModel = {
	Id: string;
	Name: string;
	Content: ActivityModel[];
	SchemaValues?: SchemaValueModel[];
	InputSchema?: SchemaRefModel;
	InputSchemaValue?: SchemaValueBindingModel;
	OutputSchema?: SchemaRefModel;
	OutputSchemaValue?: SchemaValueBindingModel;
	RuntimeSettings?: FlowRuntimeSettingsModel;
};

export type TransitionModel = {
	Id: string;
	To: string;
	Type?: string;
	Metadata?: Record<string, unknown>;
	Condition?: Record<string, unknown>;
	InputOverrides?: ActivityTransitionAgentToolInputOverride[];
};

export type FlowRuntimeSettingsModel = {
	StoreTransitions?: boolean;
	TraceEnabled?: boolean;
	StoreVariables?: boolean;
	DeleteAfter?: string;
	AttributeCaptures?: FlowAttributeCaptureModel[];
};

export const AGENT_TOOL_TRANSITION_TYPE = 'AgentTool';
/** Stable metadata category values emitted by activity-definition APIs. */
export const AGENT_TOOL_INPUT_CATEGORY = 'AgentTool.Input';
export const AGENT_TOOL_OUTPUT_CATEGORY = 'AgentTool.Output';
export const AGENT_TOOL_INPUT_SCHEMA_CATEGORY = 'AgentTool.InputSchema';
export const AGENT_TOOL_OUTPUT_SCHEMA_CATEGORY = 'AgentTool.OutputSchema';

export type FlowAttributeCaptureModel = {
	Key: string;
	Value: string;
};
